module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/432.14694273.png";